import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingPersonRequirementsBulkUpdateUpsert, ITrainingPersonRequirement, IGetPatchRequest } from '../../interfaces'

const getBulkUpdateTrainingPersonRequirementsMutationRequest: IGetPatchRequest = params => {

  return {
    method: 'patch',
    url: `${config.baseUrl}/PersonTrainingRequirements/person/`,
  }
}

const useBulkUpdateTrainingPersonRequirementsMutation: IUseUpdateMutation<ITrainingPersonRequirement, ITrainingPersonRequirementsBulkUpdateUpsert> = (params, options = {}) => {
  const request = useMemo(() => getBulkUpdateTrainingPersonRequirementsMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingPersonRequirementsBulkUpdateUpsert, ITrainingPersonRequirement> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.personId + '/dates', data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPersonRequirement, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useBulkUpdateTrainingPersonRequirementsMutation
